import { useState, useEffect} from "react";
import {CommonDialogBox} from "components";
import { Box, Stack, DialogProps, Select, Tooltip } from "@mui/material";
//import Select from '@material-ui/core/Select';
import { Button } from '@mui/material';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { voxbmrotation } from "constants/common";
import { useDispatch, useSelector} from 'react-redux';
//import { closeOrthoVoxelTerrainDialog} from 'store/main/viewObjects';
import { RootState } from 'store';
import { styled } from "@mui/material/styles";
import LinearProgress from '@mui/material/LinearProgress';
import AlertNotification from "components/AlertNotification";
import { makeStyles } from "@material-ui/core/styles";
import jwtService from 'services/jwtService';
import { getCachedData } from "api/Cache";
import NotificationMsg from "panels/CreateProcessPanel/NotificationMsg";
import NotificationModel from 'components/notificationPanel/model/NotificationModel';
import { addNotification } from 'components/notificationPanel/store/dataSlice';
import { config } from "config";
import axios from 'axios';
import AuthService from "services/AuthService";
import EventsEmitter from "events/EventsEmitter";
import {rawDataSources} from "constants/common";
import { trackEvent } from "components/Tracking";

function ProcessPanelLayout1(props:any) {
    const org = config.org;
    //const org = useSelector((state: RootState) => state.auth.data.org);

    const {project, catalogId, name, file_type, source_type, closeDialog, state, helpLinkCode, isFolder} = props;
   
    

    const data = getCachedData();
    const dispatch = useDispatch();
    const viewObject = useSelector((state: RootState) => state.main.viewObject);
    const { objSources, objType } = viewObject;
    const [itemName, setItemName] = useState('New ' + name)
    const [itemNameError, setItemNameError] = useState(false)
    const [helperItemName, setHelperItemName] = useState('')
    const [message, setMessage] = useState('')
	const [alertType, setAlertType] = useState('')
	const [loading, setLoading] = useState(false)
	const [progress, setProgress] = useState(false)
    const [orthovoxtranslateX, setorthovoxtranslateX] = useState<number>(0)
    const [orthovoxtranslateY, setorthovoxtranslateY] = useState<number>(0)
    const [orthovoxtranslateZ, setorthovoxtranslateZ] = useState<number>(0)
    const [orthovoxscaleX, setorthovoxscaleX] = useState(1)
    const [orthovoxscaleY, setorthovoxscaleY] = useState(1)
    const [orthovoxscaleZ, setorthovoxscaleZ] = useState(1)
    const [orthovoxRotateX, setOrthovoxRotateX] = useState<number>(0)
    const [orthovoxRotateY, setOrthovoxRotateY] = useState<number>(0)
    const [orthovoxRotateZ, setOrthovoxRotateZ] = useState<number>(0)
    const [source, setSource] = useState([])
    const [captureDate, setCaptureDate] = useState<any>(null)
    const [orthovoxRotateOrder, setOrthovoxRotateOrder] = useState('ZXZ')
    const [fileDate, setFileDate] = useState('')

    const [horizontalDatum, setHorizontalDatum] = useState('')
    const [verticalDatum, setVerticalDatum] = useState('')
    const [projections, setProjections] = useState('')
    const [horizontalUnits, setHorizontalUnits] = useState('')
    const [verticalUnits, setVerticalUnits] = useState('')

    const [coordOriginX, setCoordOriginX] = useState('')
    const [coordOriginY, setCoordOriginY] = useState('')
    const [coordOriginZ, setCoordOriginZ] = useState('')
    const [voxelSize, setVoxelSize] = useState('')
   
    const [listObjects, setListObjects] = useState<any>([])

    const closeComposeDialog: DialogProps["onClose"] = (event, reason) => {

        if (reason && reason === "backdropClick")
            return;

        if(reason === "escapeKeyDown")
             cancel()
    }

	const cancel = () => {
        dispatch(closeDialog({}))
        setSource([])
	}
 
    const handleName = (e:any) => {
        setItemName(e.target.value)
        if(e.target.value === ''){
            setItemNameError(true);
            setHelperItemName("Please select a name");
        }else{
            setItemNameError(false);
            setHelperItemName("");
        }
    }

    const useStyles = makeStyles({
        select: {
          fontSize: "13px", 
          height: "10px",
        },
    });

    const classes = useStyles();


    const CustomMenuItem = styled(MenuItem)(({ theme }) => ({
        "&:hover": {
            backgroundColor: "#1275aa", // light blue hover
            color: "#fff",
        },
        "&.Mui-selected": {
            backgroundColor: "#fff",
            position: "relative",
        },
        "&.Mui-selected:hover": {
            backgroundColor: "#1275aa",
            color: "#fff"
        },
        "&.Mui-selected::after": {
            content: '""',
            position: "absolute",
            right: 12,
            top: "50%",
            transform: "translateY(-50%)",
            width: 16,
            height: 16,
            backgroundImage: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='black' viewBox='0 0 24 24'><path d='M20.285 6.709l-11.285 11.293-5.285-5.293 1.41-1.41 3.875 3.879 9.875-9.879z'/></svg>")`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
        },
    }));
    
    const projectFiles = objSources.filter(
        (item: any) => item.file_folder === "0" && item.type === objType
    );

    const folderItems = objSources
    .filter((item: any) => item.type === "FOLDER" && item.project === project)
    .flatMap((folder: any) => {
        const files = objSources.filter(
            (item: any) => item.file_folder === folder.id && item.type === objType
        );

        if (files.length === 0) return [];

        return [
            <MenuItem disabled key={`${folder.id}-header`}>
                {folder.name.toUpperCase()}
            </MenuItem>,
            ...files.map((file: any) => (
                <CustomMenuItem value={file.id} key={file.id}>
                    {file.name}
                </CustomMenuItem>
            )),
            <div style={{ margin:'5px 0', borderTop : '1px solid #ededed' }}></div>
        ];
    });

    // Combine folderItems and projectFiles
    const allMenuItems = [
        ...folderItems,
        ...(projectFiles.length > 0
            ? [
                <MenuItem disabled key="project-header">PROJECT CONTENTS</MenuItem>,
                ...projectFiles.map((file: any) => (
                    <CustomMenuItem value={file.id} key={file.id}>
                        {file.name}
                    </CustomMenuItem>
                )),
            ]
            : []),
    ];
    
    const DialogAction = () => {
        return (
            <>
                <Button onClick={cancel}>Cancel</Button>
                <Button 
                    variant="contained"
                    disabled={source.length === 0 ? true : false}
                    color="primary"
                    type="submit" onClick={() => {
                        trackEvent("Process", name, "Create");
                        create();
                    }}
                >
                    Create
                </Button>
            </>
        )
    }

    const create = async () => {

            
        if(source.length === 0)
            return false;

        const payload = {
            name: itemName,
            source : source.join(" "),
            capture_date: Date.now().toString(),
            type: "FILE",
            state: "PARTIAL",
            file_type: file_type,
            file_size: "0",
            file_date: fileDate,
            file_folder: isFolder ? catalogId : "0",
            translate_x: orthovoxtranslateX.toString(),
            translate_y: orthovoxtranslateY.toString(),
            translate_z: orthovoxtranslateZ.toString(), 
            scale_x: orthovoxscaleX.toString(),
            scale_y: orthovoxscaleY.toString(),
            scale_z: orthovoxscaleZ.toString(),
            rotate_x: orthovoxRotateX.toString(),
            rotate_y: orthovoxRotateY.toString(),
            rotate_z: orthovoxRotateZ.toString(),
            rotation_order: orthovoxRotateOrder,
            coord_origin_x: coordOriginX.toString(),
            coord_origin_y: coordOriginY.toString(),
            coord_origin_z: coordOriginZ.toString(),
            coord_hdatum: horizontalDatum,
            coord_vdatum: verticalDatum,
            coord_projection: projections,
            coord_projection_tm_falseEasting: "0.0",
            coord_projection_tm_falseNorthing: "0.0",
            coord_projection_tm_latOriginDeg: "0.0",
            coord_projection_tm_longMeridianDeg: "0.0",
            coord_projection_tm_scaleFactor: "0.0",
            coord_projection_lcc_falseEasting: "0.0",
            coord_projection_lcc_falseNorthing: "0.0",
            coord_projection_lcc_latOfOriginDeg: "0.0",
            coord_projection_lcc_longOfOriginDeg: "0.0",
            coord_projection_lcc_firstStdParallelDeg: "0.0",
            coord_projection_lcc_secondStdParallelDeg: "0.0",
            coord_projection_aeac_falseEasting: "0.0",
            coord_projection_aeac_falseNorthing: "0.0",
            coord_projection_aeac_latOfOriginDeg: "0.0",
            coord_projection_aeac_longOfOriginDeg: "0.0",
            coord_projection_aeac_firstStdParallelDeg: "0.0",
            coord_projection_aeac_secondStdParallelDeg: "0.0",
            coord_projection_amg_zone: "48",
            coord_unit: horizontalUnits,
            voxel_size: voxelSize
        }
       
        const response = await jwtService.fetchRequest({
			method: 'POST',
			url: `/entity.ashx?project=${project}`,
			data: (file_type === 'VOXBM' ? {...payload, bm_type: 'VOXBM2'} : payload),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
		});

		const data = response.data;

        if(data.result === 'success') {
            const id = data.id;
            const formData = new FormData();
            formData.append("process", `IMPORT_${file_type}`);

            const response = await axios.post(`/events.ashx?project=${project}&id=${id}&org=${org}`, formData, {
            headers: { 
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${AuthService.getToken()}`,
                },
            });

            if(response.data.result === 'success'){
                dispatch(addNotification(NotificationModel({ message: <NotificationMsg msg={itemName}/>, options: { variant: 'success' } })));
                EventsEmitter.emit("reloadData", "");
            }else{
                dispatch(addNotification(NotificationModel({ message: 'An error occurs during the process upload', options: { variant: 'error' } })));
            }

        }else{
            dispatch(addNotification(NotificationModel({ message: 'An error occurs during the process upload', options: { variant: 'error' } })));
        }
        setTimeout(() => {
            dispatch(closeDialog({}))
        }, 100);
        
    }

    useEffect(() => {
       
        var allEntities = data["entities"][project];
        let allObjts : {type : string, name : string, id : string}[] = [];
        if(typeof allEntities !== "undefined") {
            const keys = Object.keys(allEntities);
            keys.forEach((key, index)  => {
                
                if(allEntities[key]['type'] === 'FILE' && (allEntities[key]['file_type'] === source_type)){
                    allObjts.push({type: allEntities[key]['file_type'], name: allEntities[key]['name'], id : allEntities[key]['ID']})
                }
            })
            setListObjects(allObjts);
        }
    }, [data, project])

    useEffect(() => {
        const projects: any = data["projects"][project];
        setCaptureDate(Date.now())
        setHorizontalDatum(projects['coord_hdatum'])
        setVerticalDatum(projects['coord_vdatum'])
        setProjections(projects['coord_projection'])
        setHorizontalUnits(projects['coord_unit'])
        setVerticalUnits(projects['coord_unit'])
        setFileDate(projects['file_date'])
        setCoordOriginX(projects['coord_origin_x'])
        setCoordOriginY(projects['coord_origin_y'])
        setCoordOriginZ(projects['coord_origin_z'])
        setVoxelSize(projects['voxel_size'])
    }, [data, project])
    
    return (
		<>
            <CommonDialogBox
                classes={{
                    paper: 'm-5 rounded-8 white-bg'
                }}
                open={state}
                handleClose={closeComposeDialog}
                fullWidth
                maxWidth="sm"
                subtitle1={`New ${name}`}
                titleh5=''
                dialogAction={objSources.filter((item:any) => item.type === objType && item.project === project).length > 0 ? <DialogAction /> : ''}
                displayScrollBar={true}
                maxHeight={400}
                helpLinkCode={helpLinkCode}
            >
                <div id="progressContainer" style={{ display:'none' }}></div>
                {
                loading && (
                    <>
                    <AlertNotification variant={"standard"} type={alertType} message={message} />
                    {
                    progress && (
                        <Box sx={{ width: '100%' }}>
                            <LinearProgress />
                        </Box>
                        )
                    }
                    </>
                    )
                }
                {
                objSources.filter((item:any) => item.type === objType && item.project === project).length > 0 ?
                <Stack 
                    gap={1}
                >
                    <Tooltip title="A descriptive, readable name for the new entity" placement="top" arrow>
                        <TextField
                            sx={{
                                "& .MuiInputBase-root": {
                                height: "35px", // Set your desired height
                                fontSize : '13px'
                                },
                            }}
                            required
                            margin="dense"
                            id="itemName"
                            name="itemName"
                            label="Item Name"
                            error={itemNameError}
                            helperText={helperItemName}
                            value={itemName}
                            type="txt"
                            fullWidth
                            color='primary'
                            variant="outlined"
                            onChange={(e) => handleName(e)}
                            style={{marginBottom: '10px'}}
                        /> 
                    </Tooltip>
                    <Tooltip title="Shows a list of available raw Mesh entities. From this list, you can select which raw Mesh will be used to create the Indexed Mesh." placement="top" arrow>
                        <Select
                            required
                            margin="dense"
                            id="orthovox-select-mesh"
                            name="orthovox-select-mesh"
                            label="Source Mesh"
                            value={source}
                            displayEmpty
                            // classes={{ root: classes.select }}
                            multiple
                            type="txt"
                            fullWidth
                            color='primary'
                            variant="outlined"
                            onChange={(e:any) => setSource(e.target.value)}
                            sx={{ '.MuiPaper-root': { backgroundColor: "revert", color: "revert" } }}
                        >
                            {
                                // objSources.filter((item:any) => item.type === objType && item.project === project).map((elem:any, index:any) => <CustomMenuItem value={elem.id} key={index}>{elem.name}</CustomMenuItem>)
                                allMenuItems
                            }
                        </Select>
                    </Tooltip>

                    <Tooltip title="These fields allow translating the mesh position by the specified amounts along each coordinate axis" placement="top" arrow>
                        <TextField
                            sx={{
                                "& .MuiInputBase-root": {
                                height: "35px", // Set your desired height
                                fontSize : '13px'
                                },
                            }}
                            required
                            margin="dense"
                            id="orthovox-translate-x"
                            name="orthovox-translate-x"
                            label="Translate X"
                            value={orthovoxtranslateX}
                            type="txt"
                            fullWidth
                            color='primary'
                            variant="outlined"
                            onChange={(e) => setorthovoxtranslateX(parseInt(e.target.value))}
                        /> 
                    </Tooltip>

                    <Tooltip title="These fields allow translating the mesh position by the specified amounts along each coordinate axis" placement="top" arrow>
                   <TextField
                        sx={{
                            "& .MuiInputBase-root": {
                            height: "35px", // Set your desired height
                            fontSize : '13px'
                            },
                        }}
                        required
                        margin="dense"
                        id="orthovox-translate-y"
                        name="orthovox-translate-y"
                        label="Translate Y"
                        value={orthovoxtranslateY}
                        type="txt"
                        fullWidth
                        color='primary'
                        variant="outlined"
                        onChange={(e) => setorthovoxtranslateY(parseInt(e.target.value))}
                    />
                    </Tooltip>

                    <Tooltip title="These fields allow translating the mesh position by the specified amounts along each coordinate axis" placement="top" arrow>
                        <TextField
                            sx={{
                                "& .MuiInputBase-root": {
                                height: "35px", // Set your desired height
                                fontSize : '13px'
                                },
                            }}
                            required
                            margin="dense"
                            id="orthovox-translate-z"
                            name="orthovox-translate-z"
                            label="Translate Z"
                            value={orthovoxtranslateZ}
                            type="txt"
                            fullWidth
                            color='primary'
                            variant="outlined"
                            onChange={(e) => setorthovoxtranslateZ(parseInt(e.target.value))}
                        />
                    </Tooltip> 

                    <Tooltip title="These fields allow scaling the mesh by the specified amounts along each coordinate axis. A value of 1.0 represents the original scale" placement="top" arrow>
                    <TextField
                        sx={{
                            "& .MuiInputBase-root": {
                            height: "35px", // Set your desired height
                            fontSize : '13px'
                            },
                        }}
                        required
                        margin="dense"
                        id="orthovox-scale-x"
                        name="orthovox-scale-x"
                        label="Scale X"
                        type="txt"
                        fullWidth
                        value={orthovoxscaleX}
                        color='primary'
                        variant="outlined"
                        onChange={(e) => setorthovoxscaleX(parseInt(e.target.value))}
                    /> 
                    </Tooltip>
                    <Tooltip title="These fields allow scaling the mesh by the specified amounts along each coordinate axis. A value of 1.0 represents the original scale" placement="top" arrow>
                    <TextField
                        sx={{
                            "& .MuiInputBase-root": {
                            height: "35px", // Set your desired height
                            fontSize : '13px'
                            },
                        }}
                        required
                        margin="dense"
                        id="orthovox-scale-y"
                        name="orthovox-scale-y"
                        label="Scale Y"
                        type="txt"
                        fullWidth
                        value={orthovoxscaleY}
                        color='primary'
                        variant="outlined"
                        onChange={(e) => setorthovoxscaleY(parseInt(e.target.value))}
                    /> 
                    </Tooltip>
                    <Tooltip title="These fields allow scaling the mesh by the specified amounts along each coordinate axis. A value of 1.0 represents the original scale" placement="top" arrow>
                        <TextField
                            sx={{
                                "& .MuiInputBase-root": {
                                height: "35px", // Set your desired height
                                fontSize : '13px'
                                },
                            }}
                            required
                            margin="dense"
                            id="orthovox-scale-z"
                            name="orthovox-scale-z"
                            label="Scale Z"
                            type="txt"
                            fullWidth
                            value={orthovoxscaleZ}
                            color='primary'
                            variant="outlined"
                            onChange={(e) => setorthovoxscaleZ(parseInt(e.target.value))}
                        /> 
                    </Tooltip>

                    <Tooltip title="Euler rotation angles for each coordinate axis." placement="top" arrow>
                    <TextField
                        sx={{
                            "& .MuiInputBase-root": {
                            height: "35px", // Set your desired height
                            fontSize : '13px'
                            },
                        }}
                        required
                        margin="dense"
                        id="orthovox-rotate-x"
                        name="orthovox-rotate-x"
                        label="Rotate X"
                        type="txt"
                        fullWidth
                        value={orthovoxRotateX}
                        color='primary'
                        variant="outlined"
                        onChange={(e) => setOrthovoxRotateX(parseInt(e.target.value))}
                    /> 
                    </Tooltip>
                    <Tooltip title="Euler rotation angles for each coordinate axis." placement="top" arrow>
                    <TextField
                        sx={{
                            "& .MuiInputBase-root": {
                            height: "35px", // Set your desired height
                            fontSize : '13px'
                            },
                        }}
                        required
                        margin="dense"
                        id="orthovox-rotate-y"
                        name="orthovox-rotate-y"
                        label="Rotate Y"
                        type="txt"
                        fullWidth
                        value={orthovoxRotateY}
                        color='primary'
                        variant="outlined"
                        onChange={(e) => setOrthovoxRotateY(parseInt(e.target.value))}
                    /> 
                    </Tooltip>
                    <Tooltip title="Euler rotation angles for each coordinate axis." placement="top" arrow>
                    <TextField
                        sx={{
                            "& .MuiInputBase-root": {
                            height: "35px", // Set your desired height
                            fontSize : '13px'
                            },
                        }}
                        required
                        margin="dense"
                        id="orthovox-rotate-z"
                        name="orthovox-rotate-z"
                        label="Rotate Z"
                        type="txt"
                        fullWidth
                        value={orthovoxRotateZ}
                        color='primary'
                        variant="outlined"
                        onChange={(e) => setOrthovoxRotateZ(parseInt(e.target.value))}
                    /> 
                    </Tooltip>
      
                    <Tooltip title="Euler rotation angle sequence." placement="top" arrow>
                        <TextField
                            sx={{
                                "& .MuiInputBase-root": {
                                height: "35px", // Set your desired height
                                fontSize : '13px'
                                },
                            }}
                            required
                            margin="dense"
                            id="orthovox-select-rotation-order"
                            name="orthovox-select-rotation-order"
                            label="Rotate Order"
                            type="txt"
                            select
                            fullWidth
                            value={orthovoxRotateOrder}
                            color='primary'
                            variant="outlined"
                            onChange={(e) => setOrthovoxRotateOrder(e.target.value)}
                        >
                            {
                                voxbmrotation.map(item => <MenuItem value={item.value} key={item.value}>{item.text}</MenuItem>)
                            }
                        </TextField> 
                   </Tooltip>
                </Stack>
                :
                <div style={{display:'flex', justifyContent:'center',alignItems: 'center', height: '30vh'}}>
                    {
                    `No "${rawDataSources[objType]}" data source found`
                    }
                </div>
                }
            </CommonDialogBox>
		</>
  	)
}

export default ProcessPanelLayout1